export default {
    // getFactorys : (state) =>{
    //     return state.factorys;
    // }
    
}